import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  isTaskStatusTypeNo,
  isTaskStatusTypeYes,
  TaskStatusToggle,
  TaskStatusType,
} from '../../../../../Task'
import { useCalendarContext } from '../../../../Calendar.hooks'

import {
  QA_NAME_CALENDAR_ITEM_CARD_STEP_NO,
  QA_NAME_CALENDAR_ITEM_CARD_STEP_YES,
} from './CalendarItemCardStepYesNo.constants'
import {
  getCalendarItemCardStepYesNoValue,
  getIsCalendarItemCardStepSaving,
} from './CalendarItemCardStepYesNo.utils'

import * as styles from './CalendarItemCardStepYesNo.module.css'

function CalendarItemCardStepYesNo({ step }) {
  const { t } = useTranslation()

  const { onChangeTaskStatus } = useCalendarContext()

  const [loadingType, setLoadingType] = useState(null)

  const isDisabled =
    !step.canEdit || getIsCalendarItemCardStepSaving(loadingType)

  const tooltip = step.canEdit ? null : t('Calendar.NoEditTaskKey')

  function getHandleChange(type) {
    return () => {
      setLoadingType(type)

      onChangeTaskStatus({
        changes: {
          yesno: getCalendarItemCardStepYesNoValue({ type, yesno: step.yesno }),
        },
        task: step,
      }).finally(() => {
        setLoadingType(null)
      })
    }
  }

  return (
    <div className={styles.CalendarItemCardStepYesNo}>
      <TaskStatusToggle
        checked={isTaskStatusTypeYes(step.yesno)}
        disabled={isDisabled}
        isLoading={isTaskStatusTypeYes(loadingType)}
        qaName={QA_NAME_CALENDAR_ITEM_CARD_STEP_YES}
        text={t('TaskTable.StatusYesKey')}
        tooltip={tooltip}
        type={TaskStatusType.Yes}
        onChange={getHandleChange(TaskStatusType.Yes)}
      />
      <TaskStatusToggle
        checked={isTaskStatusTypeNo(step.yesno)}
        disabled={isDisabled}
        isLoading={isTaskStatusTypeNo(loadingType)}
        qaName={QA_NAME_CALENDAR_ITEM_CARD_STEP_NO}
        text={t('TaskTable.StatusNoKey')}
        tooltip={tooltip}
        type={TaskStatusType.No}
        onChange={getHandleChange(TaskStatusType.No)}
      />
    </div>
  )
}

export default CalendarItemCardStepYesNo
